<div class="modal-footer bg-light d-flex align-items-center justify-content-between">
  <div class="py-2">{{ folderElement }} {{ folderElement === 1 ? 'elemento' : 'elementi' }}</div>
  <div class="d-flex align-items-center gap-2">
    <ng-container *ngIf="moveFiletoggle; else newFolder">
      <button mat-button (click)="moveFiletoggleHandler.emit(false)">Annulla</button>
      <button mat-flat-button [disabled]="selectedNode.path === activeNode.path" (click)="moveFiletoggleHandler.emit(false); moveHandler.emit(true)">
        Sposta qui
      </button>
    </ng-container>
  </div>
</div>

<ng-template #newFolder>
  <button mat-flat-button (click)="createNewFolder.emit()" [disabled]="!activeNode?.isEditable">Nuova cartella</button>
</ng-template>
